import { render, staticRenderFns } from "./historyModal.vue?vue&type=template&id=59fb5c16&scoped=true&"
import script from "./historyModal.vue?vue&type=script&lang=js&"
export * from "./historyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fb5c16",
  null
  
)

export default component.exports